type LogContext = Record<string, unknown>;

function emit(level: 'info' | 'warn' | 'error', msg: string, ctx?: LogContext): void {
  const payload = { level, ts: Date.now(), msg, ...ctx };
  const fn = level === 'error' ? console.error : level === 'warn' ? console.warn : console.log;
  fn(JSON.stringify(payload));
}

export const log = {
  info: (msg: string, ctx?: LogContext): void => emit('info', msg, ctx),
  warn: (msg: string, ctx?: LogContext): void => emit('warn', msg, ctx),
  error: (msg: string, err?: unknown, ctx?: LogContext): void => {
    const errCtx =
      err instanceof Error
        ? { err: { name: err.name, message: err.message, stack: err.stack } }
        : err !== undefined
          ? { err: String(err) }
          : {};
    emit('error', msg, { ...errCtx, ...ctx });
  },
};
